
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"19","height":"19","viewBox":"0 0 19 19"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"vuesax/twotone/3dcube"}},[_c('g',{attrs:{"data-name":"3dcube","fill":"none","stroke":"#fff","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5"}},[_c('path',{attrs:{"d":"M10.229 1.789l5.154 2.779a.913.913 0 010 1.575l-5.154 2.779a1.533 1.533 0 01-1.457 0L3.618 6.143a.913.913 0 010-1.575l5.154-2.779a1.533 1.533 0 011.457 0z"}}),_c('path',{attrs:{"data-name":"Vector","d":"M2.858 8.02l4.79 2.4a1.772 1.772 0 01.974 1.575v4.53a.878.878 0 01-1.275.784l-4.79-2.4a1.772 1.772 0 01-.974-1.577V8.804a.878.878 0 011.275-.784zM16.142 8.02l-4.79 2.4a1.772 1.772 0 00-.973 1.574v4.531a.878.878 0 001.275.784l4.79-2.4a1.772 1.772 0 00.974-1.575v-4.53a.878.878 0 00-1.276-.784z","opacity":".4"}})])])])
          )
        }
      }
    